
const ConfigTab = require('app/product/price/new/ConfigTab');
const PendingTab = require('app/product/price/new/PendingTab');

class ShowView {
    defaultOptions() {
        return {
            'activeTab': 'info',
            'selector': '.view-product-price-new',

            'ranges': [],
            'suppliers': [],
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);


        this.onTabChange = this.onTabChange.bind(this);

        this.$container = $(this.settings.selector);
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.ranges = this.settings.ranges;
        this.suppliers = this.settings.suppliers;

        this.initialize();
    }

    initialize() {
        var self = this;

        $('button[data-bs-toggle="tab"]',this.$container)
        .on('shown.bs.tab',this.onTabChange);

        this.loadTab(this.settings.activeTab);
    }

    onTabChange(event){

        let $shownTabBtn = $(event.target);
        let $previousShownTabBtn = $(event.relatedTarget);

        let shownTab = $shownTabBtn.data('tab');
        let previousShownTab = $previousShownTabBtn.data('tab');

        this.clearTab(previousShownTab);
        this.loadTab(shownTab);
    }

    clearTab(tab){
        let $tabBody = $('.'+tab+'-body',this.$container);

        $tabBody.html('');
    }
    
    loadTab(tab){
        let $tabBody = $('.'+tab+'-body',this.$container);

        $tabBody.html('')
        .append(window.App.generateLoader());

        window.setUrlParameter('tab',tab);

        switch(tab){
            case 'config':
                let configTab = new ConfigTab({
                    '$container': $tabBody,
                    'view': this,
                });
            break;
            case 'pending':
                let pendingTab = new PendingTab({
                    '$container': $tabBody,
                    'view': this,
                });
            break;
            case 'check':
                let url = window.App.get('oldAdminHomeUrl') + "/products/check_waiting_prices";
                window.redirect(url,'now');
            break;
        }
    }


    buildFilterForm(onSubmitFilterForm){
        let $filterForm = $('<form/>');

        $filterForm
        .append(
            $('<div/>')
            .addClass('form-group')
            .append(
                $('<label/>')
                .attr('for','range')
                .append(window.translate('app.product.search.byRange'))
            )
            .append(this.buildFilterRange(onSubmitFilterForm))
        )
        .append(
            $('<div/>')
            .addClass('form-group')
            .append(
                $('<label/>')
                .attr('for','supplier')
                .append(window.translate('app.product.search.bySupplier'))
            )
            .append(this.buildFilterSupplier(onSubmitFilterForm))
        )
        .append(
            $('<div/>')
            .addClass('form-group')
            .append(
                $('<label/>')
                .attr('for','number')
                .append(window.translate('app.product.search.byNumber'))
            )
            .append(this.buildFilterNumber(onSubmitFilterForm))
        )
        .append(
            $('<div/>')
            .addClass('form-group')
            .append(
                $('<label/>')
                .attr('for','reference')
                .append(window.translate('app.product.search.byReference'))
            )
            .append(this.buildFilterReference(onSubmitFilterForm))
        )

        $filterForm.on('submit',onSubmitFilterForm);
        return $filterForm;
    }

    buildFilterRange(onSubmitFilterForm){
        let $filterRange = $('<select/>')
        .attr('id','range')
        .attr('name','range')
        .addClass('form-control');

        $filterRange.append(
            $('<option/>')
            .attr('selected','selected')
            .append('-')
        );

        for(var i in this.ranges){
            let range = this.ranges[i];

            let options = this.buildRangeOptions(range,0);
            for(var o in options){
                let $option = options[o];
                $filterRange.append($option);

            }

        }

        $filterRange.on('change',onSubmitFilterForm);
        return $filterRange;
    }

    buildRangeOptions(range,offset){
        if(!offset){
            offset = 0;
        }
        let options = [];
        let prefix = '';
        for(var i = 0; i < offset; i++){
            prefix += '&nbsp;&nbsp;&nbsp;&nbsp;';
        }
        let $option = $('<option/>')
        .val(range.id)
        .append(prefix + range.name);
        if(offset == 0){
            $option.addClass('fw-bold');
        }

        options.push($option);

        if(range.childs && range.childs.length > 0){
            for(var i in range.childs){
                let child = range.childs[i];

                options.push(this.buildRangeOptions(child,offset+1));
            }
        }

        return options;
    }

    buildFilterSupplier(onSubmitFilterForm){
        let $filterSupplier = $('<select/>')
        .attr('id','supplier')
        .attr('name','supplier')
        .addClass('form-control');

        $filterSupplier.append(
            $('<option/>')
            .attr('selected','selected')
            .append('-')
        );

        for(var i in this.suppliers){
            let supplier = this.suppliers[i];

            $filterSupplier.append(
                $('<option/>')
                .val(supplier.id)
                .append(supplier.name)
            );
        }

        $filterSupplier.on('change',onSubmitFilterForm);
        return $filterSupplier;
    }


    buildFilterNumber(onSubmitFilterForm){
        let $filterNumber = $('<input/>')
        .attr('id','number')
        .attr('name','number')
        .addClass('form-control');

        $filterNumber.on('change',onSubmitFilterForm);
        return $filterNumber;
    }



    buildFilterReference(onSubmitFilterForm){
        let $filterReference = $('<input/>')
        .attr('id','reference')
        .attr('name','reference')
        .addClass('form-control');

        $filterReference.on('change',onSubmitFilterForm);
        return $filterReference;
    }

}

module.exports = ShowView;

